<template>
	<div style="min-height:100vh; overflow: auto;" class="pb15">
		<div v-for="(item, i) in localTree" :key="i">
			<steps-node :node="item" @node:select="selectNode" />
		</div>
	</div>
</template>

<script>
import StepsNode from "./StepsNode"

export default {
	components: { StepsNode },

	props: {
		tree: {
			type: Array,
			default: () => [],
			example: [{ title: "Name of step", id: "id-here", isSelected: false }]
		}
	},

	data() {
		return {
			localTree: [...this.tree]
		}
	},

	methods: {
		selectNode(node) {
			const newTree = JSON.parse(JSON.stringify(this.localTree))

			const recursion = arr => {
				arr.forEach(item => {
					item.isSelected = false
					if (item.id === node.id) item.isSelected = true
					if (item?.children?.length) recursion(item.children)
				})
			}

			recursion(newTree)
			this.localTree = newTree

			// emit up
			this.$emit("node:select", node)
		}
	}
}
</script>
